import { FC, PropsWithChildren } from 'react';

import styles from 'bloko/blocks/chips/chip.less';

const MultiLineContainer: FC<PropsWithChildren> = ({ children }) => (
    <p className={styles['bloko-chips-multiline-container']}>{children}</p>
);

export default MultiLineContainer;
